<template>
  <div class="full d-flex justify-center">
    <div class="to_home pa-2">
      <a href="https://temanbakat.id/" style="text-decoration: none">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <img
              v-bind="attrs"
              v-on="on"
              src="https://temanbakat.id/welcome/wp-content/uploads/2021/08/Logo-Teman-Bakat-Baru-1-1-150x150.png"
              height="70px"
              alt=""
            />
          </template>
          <span>Back To Home</span>
        </v-tooltip>
      </a>
    </div>
    <div class="breakpoint d-flex align-center justify-center">
      <div class="temp-down" v-if="isScrolled">
        <div>
          <button v-if="toBottom" id="updown" @click="scrollDown">
            <p class="ma-0 horizon-txt"><strong>Sroll</strong></p>
            <v-icon dark>mdi-arrow-down</v-icon>
          </button>
        </div>
        <div>
          <button v-if="!toBottom" id="updown" @click="scrollTop">
            <v-icon dark>mdi-arrow-up</v-icon>
            <p class="ma-0 horizon-txt"><strong>Top</strong></p>
          </button>
        </div>
      </div>
      <div class="intro">
        <Iwant v-if="$route.params.type == 'tespilihankerja'" />
        <Iam v-if="$route.params.type == 'teskarakter'" />
        <Ineed v-if="$route.params.type == 'testujuankerja'" />
        <Ican v-if="$route.params.type == 'teskemampuankerja'" />
        <Perception v-if="$route.params.type == 'tescarabelajar'" />
        <Sociability v-if="$route.params.type == 'teskemampuansosial'" />
        <Aggression v-if="$route.params.type == 'tesemosi'" />
        <Inconsistency v-if="$route.params.type == 'tesbidangpekerjaan'" />
        <WorkingStyle v-if="$route.params.type == 'tesgayakerja'" />
        <StressKerjaResult v-if="$route.params.type == 'streskerja'" />
      </div>
    </div>
  </div>
</template>

<script>
import Aggression from "./aggressionResult.vue";
import Iam from "./iamResult.vue";
import Ican from "./icanResult.vue";
import Inconsistency from "./inconsistencyResult .vue";
import Ineed from "./ineedResult.vue";
import Iwant from "./iwantResult.vue";
import Perception from "./perceptionResult.vue";
import Sociability from "./sociabilityResult.vue";
import StressKerjaResult from "./stressKerjaResult.vue";
import WorkingStyle from "./workingStyleResult.vue";
export default {
  components: {
    Iwant,
    Iam,
    Ineed,
    Ican,
    Aggression,
    Perception,
    Sociability,
    Inconsistency,
    WorkingStyle,
    StressKerjaResult,
  },
  name: "mainResult",

  data() {
    return {
      isScrolled: true,
      toBottom: true,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
      if (window.innerHeight + window.scrollY == document.body.offsetHeight) {
        this.isScrolled = false;
        console.log("have no scrolll");
      }
    }, 600);

    let vm = this;
    // eslint-disable-next-line
    window.onscroll = function (ev) {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        vm.toBottom = false;
      } else {
        vm.toBottom = true;
      }
    };
  },
  methods: {
    scrollDown() {
      window.scrollBy(0, 100);
    },
    scrollTop() {
      window.scrollTo(0, 0);
      this.toBottom = true;
    },
  },
};
</script>

<style scoped>
.temp-down {
  z-index: 2;
  position: fixed;
  right: 10px;
  bottom: 30px;
}
.sticky_elmnt {
  z-index: 2;
  position: -webkit-sticky;
  position: sticky;
  top: 90px;
  background: white;
}
.horizon-txt {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
#updown {
  background: #910b62;
  color: white;
  padding: 10px 5px;
  border-radius: 5px;
  animation: towewew infinite ease-in-out alternate 0.8s;
  animation-delay: 0.5s;
}
@keyframes towewew {
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(0, 50%);
  }
}
</style>
